
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CustomButton, Card } from 'ui-library'

@Component({ components: { Card, CustomButton } })
export default class ImageWrapper extends Vue {
  @Prop({ required: true }) private imagePath!: string
  @Prop({ required: true }) private imageName!: string
  @Prop({ required: true }) private breakpoints!: Array<number>
  @Prop({ default: true }) private renderAsRow!: boolean

  private assetsBaseUrl: string = window.ENV_CONFIG.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''
}
